import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from 'assets/img/icons/MenuIcon';
import { toggleNavbar } from 'core/store/navbarSlice';
import { useDispatch } from 'react-redux';
import { DARKER_GREY, MAIN_BOX_SHADOW } from 'utils/theme';
import UserAvatarWithMenu from '../components/UserAvatarWithMenu';
import NavbarLogo from './components/NavbarLogo';
import NavbarToggler from './components/NavbarToggler';

const NavBar = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('desktop'));

  return (
    <Box
      bgcolor="white"
      display="flex"
      alignItems="center"
      boxShadow={MAIN_BOX_SHADOW}
      zIndex={1000}
      sx={{
        flexDirection: { mobile: 'row', tablet: 'row', desktop: 'column' },
        width: {
          mobile: '100%',
          tablet: '100%',
          desktop: '145px',
        },
        height: { mobile: '56px', tablet: '56px', desktop: '100vh' },
        borderRadius: { mobile: '50px', tablet: '50px', desktop: 0 },
        padding: { mobile: '0 24px', tablet: '0 35px', desktop: 0 },
        margin: { mobile: '16px', tablet: '24px', desktop: 0 },
        position: { mobile: 'unset', tablet: 'unset', desktop: 'fixed' },
        justifyContent: {
          mobile: 'space-between',
          tablet: 'space-between',
          desktop: 'flex-start',
        },
        boxSizing: 'border-box',
      }}
    >
      <NavbarLogo />
      {isSmallScreen && <UserAvatarWithMenu />}
      {!isSmallScreen && <NavbarToggler />}
      {isSmallScreen && (
        <Button
          onClick={() => dispatch(toggleNavbar())}
          sx={{
            padding: 0,
            minWidth: 'unset',
            width: '40px',
            height: '40px',
          }}
        >
          <MenuIcon stroke={DARKER_GREY} />
        </Button>
      )}
    </Box>
  );
};

export default NavBar;
